module.exports = __webpack_public_path__ + "static/img/home_banner1@2x.ed0ffdff.png";